export const APP_GREETING = "APP/GREETING";
export const GET_POKEMON_LIST = "APP/GET_POKEMON_LIST";
export const SET_POKEMON_LIST = "APP/SET_POKEMON_LIST";
